import React from "react";

interface SubmenuHeaderProps {
    onBackClick: () => void;
}

const SubmenuHeader: React.FC<SubmenuHeaderProps> = ({ onBackClick }) => {
    return (
        <span
            className="text-subtitle-4 items-center pt-1  font-normal text-primary-text mb-[24px] lg:hidden flex"
            onClick={onBackClick}
        >
            <svg
                width="16"
                className="mt-[-5px]"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.99998 13.2802L5.65331 8.93355C5.13998 8.42021 5.13998 7.58022 5.65331 7.06688L9.99998 2.72021"
                    stroke="#040405"
                    strokeWidth="1.25"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>{" "}
            Back To Menu
        </span>
    );
};

export default SubmenuHeader;
